/**
 * Root reducer.
 *
 * Matches the template's `app/store/rootReducer.ts` shape: import the
 * registerApis side-effect module first so feature API endpoints inject
 * into baseApi BEFORE this file references baseApi.reducer. Then
 * combineReducers with our auth slice + baseApi.
 *
 * Why split this from store/index.ts (vs putting everything in one file):
 *   It's the template convention. Keeping the store configuration small
 *   and the reducer composition in its own file means swapping in
 *   additional slices (settings, notifications, etc.) is a localized
 *   change.
 */
import { combineReducers } from "@reduxjs/toolkit";

import "@/app/store/registerApis"; // side-effect: inject feature endpoints
import { baseApi } from "@/app/store/api/baseApi";

import { authReducer } from "@/features/auth/authSlice";

/** The combined root reducer (baseApi reducer plus feature slices). */
export const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  auth: authReducer,
});
